import { useState, useCallback } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fetchData, profileData } from "../slices/profileSlice";
import {
  _fetch_user_wallet_data,
  _get_profile,
  _get_user_wallet,
  _get_wallet_balance,
} from "../common/axios_services";

const useWalletData = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [majorPageSpinner, setMajorPageSpinner] = useState(false);
  const [walletBalance, setWalletBalance] = useState(0);
  const [walletData, setWalletData] = useState({});
  const [userData, setUserData] = useState({});
  const [userTransferData, setUserTransferData] = useState({});
  const [displayUserWallet, setDisplayUserWallet] = useState(true);
  const [userloginPinSet, setUserloginPinSet] = useState(false);

  const fetchUserWalletBalance = useCallback(async () => {
    try {
      const fetchUserAccountBalance = await _fetch_user_wallet_data();
      const data = fetchUserAccountBalance.data.data;
      setWalletData(data);
    } catch (err) {
      console.log({ err });
    }
  }, []);

  const fetchUser = useCallback(async () => {
    try {
      const user_profile = await _get_profile();
      dispatch(fetchData(true));
      dispatch(profileData(user_profile?.data?.data));
      const userData = user_profile?.data.data;
      setUserData(userData);
      setUserloginPinSet(!userData?.hasTransPin);
    } catch (err) {
      if (err.response?.data.message === "Unauthorized") {
        localStorage.removeItem("konnect_token");
        navigate("/signin");
      }
      dispatch(profileData(false));
      dispatch(fetchData(false));
    }
  }, [dispatch, navigate]);

  const fetchUserWallet = useCallback(async () => {
    try {
      const user_profile = await _get_user_wallet();
      const userData = user_profile?.data.data;
      setUserTransferData(userData);
      setMajorPageSpinner(false);
    } catch (err) {
      if (err.response?.data.message === "Unauthorized") {
        localStorage.removeItem("konnect_token");
        navigate("/signin");
      }
      dispatch(profileData(false));
      dispatch(fetchData(false));
    }
  }, [dispatch, navigate]);

  const getWalletBalance = useCallback(async () => {
    try {
      const balance = await _get_wallet_balance();
      const data = balance.data.data;
      setWalletBalance({
        ...data,
        balance: data.availableBalance || 0,
        bonus_bal: Number(data.bonusBalance ?? data.bonus_bal ?? 0),
        bonusBalance: Number(data.bonusBalance ?? data.bonus_bal ?? 0),
        lien_bal: data.heldAmount || 0,
      });
    } catch (err) {
      console.log({ err });
    }
  }, []);

  const handleTitleCheckChange = useCallback(() => {
    setDisplayUserWallet(!displayUserWallet);
  }, [displayUserWallet]);

  return {
    majorPageSpinner,
    walletBalance,
    walletData,
    userData,
    userTransferData,
    displayUserWallet,
    userloginPinSet,
    setUserloginPinSet,
    fetchUserWalletBalance,
    fetchUser,
    fetchUserWallet,
    getWalletBalance,
    handleTitleCheckChange,
  };
};

export default useWalletData;
